import { Navigate } from 'react-router-dom';
import { GenericErrorPage } from 'src/error/GenericErrorPage';

export default function RedirectUnknownClient() {
  if (process.env.NODE_ENV === 'development') {
    return <GenericErrorPage error="Client became 'undefined'" />;
  } else {
    return <Navigate to="/clients/all" replace />;
  }
}
